export const CATEGORY_KEYS: Record<string, string> = {
  Chemical: 'chemical',
  Fertilizer: 'fertilizer',
  Probiotic: 'probiotic',
  'Feed-Addative': 'feedAddative',
};
